module.exports = __webpack_public_path__ + "media/images/icons/outlined/eye-e91d78b91d2bf8cff6b081573743ccd2.svg";